<template>
  <div>
    <div v-if="isLoading" class="loader"></div>
    <div v-if="!isLoading">
      <div class="header-group">
        <h2 style="margin: 0px; font-weight: bold; text-transform: uppercase">
          {{ title }}
        </h2>
        <div>
          <div v-if="isSubmitting" class="loader"></div>
          <button
            v-if="id < 0 && !isSubmitting"
            class="button dark-blue"
            @click="submitNew()"
          >
            SUBMIT
          </button>
          <template v-if="canEdit() && id > 0">
            <div class="header-btn-group">
              <button
                v-if="!isArchived"
                class="button green btn-spacing"
                @click="sendLogin()"
              >
                SEND LOGIN DETAILS
              </button>

              <button
                v-if="!isArchived"
                class="button dark-blue btn-spacing"
                @click="archive()"
              >
                ARCHIVE EMPLOYEE
              </button>
              <div class="red-col" v-else>Archived Employee</div>
            </div>
          </template>
        </div>
      </div>
      <div
        :class="isSubmitting ? 'flex-grid unclickable' : 'flex-grid'"
        v-for="(form, index) in forms"
        :key="index"
      >
        <div
          v-for="(formCol, index) in form"
          :key="index"
          :class="formCol.length > 1 ? 'col flex-grid-row' : 'col'"
        >
          <Form
            v-for="(f, index) in formCol"
            :key="index"
            :id="id"
            :title="f.title"
            :isUpdating.sync="f.isUpdating"
            :isSubmitting.sync="f.isSubmitting"
            :isEditable="f.isEditable !== false && canEdit()"
            :model="f.model"
            :endpoint="'employees'"
          ></Form>
        </div>
      </div>
      <StaffDocs v-if="id >= 0" :profile="profile" :id="id" />
      <AttendanceLog v-if="id >= 0 && canEdit()" :id="id" :profile="profile" />
    </div>
    <Notif v-if="notif" :data.sync="notif" :anchor="'top'"></Notif>
  </div>
</template>

<script>
import { utils, http } from '../digilib_web/core/digitify';
import { constants } from '../js/regents';
import Notif from '../digilib_web/vue/notif';
import Form from './common/form';
import AttendanceLog from './attendance_log';
import StaffDocs from './staff_documents';

export default {
  props: {
    id: Number,
    profile: Object,
    title: String,
    banks: Array
  },
  watch: {
    forms: {
      handler(n) {
        for (let i = 0; i < n.length; ++i) {
          for (let j = 0; j < n[i].length; ++j) {
            for (let k = 0; k < n[i][j].length; ++k) {
              if (n[i][j][k].isSubmitting) {
                if (n[i][j][k].isUpdating) {
                  let payload = utils.toPayload(n[i][j][k].model);
                  http.put(`employees/${this.id}`, payload).then(json => {
                    this.notif = utils.notif('Successfully Updated!', json);
                    if (json.success) {
                      this.resetFormActions();
                      this.reload(this.id);
                    }
                  });
                }
              }
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    sendLogin() {
      if (
        confirm(
          `Are you sure you want to send login details to this employee ?`
        )
      ) {
        this.isLoading = true;
        http.post(`send-login`, { id: this.id }).then(json => {
          console.log(json);
          this.isLoading = false;
          alert(
            json.success
              ? 'Email successfully sent'
              : 'Fail to send email, check with your admin for more info'
          );
        });
      }
    },
    archive() {
      if (confirm(`Are you sure you want to archive this employee ?`)) {
        let payload = { is_archived: true };
        http.put(`employees/${this.id}`, payload).then(json => {
          this.notif = utils.notif('Employee Archived!', json);
          if (json.success) {
            this.isArchived = true;
          }
        });
      }
    },
    canEdit() {
      return this.profile.role === 'admin';
    },
    reload: function(id) {
      http.get(`employees/${id}`).then(json => {
        this.setFormData(json.data);
        this.$emit('update:title', json.data.name);
      });
    },
    getAllPayload: function() {
      let payloads = {};
      // merge all model in the form(s)
      for (let i = 0; i < this.forms.length; ++i) {
        for (let j = 0; j < this.forms[i].length; ++j) {
          for (let k = 0; k < this.forms[i][j].length; ++k) {
            payloads = Object.assign(
              payloads,
              utils.toPayload(this.forms[i][j][k].model)
            );
          }
        }
      }
      return payloads;
    },
    submitNew: function() {
      this.isSubmitting = true;
      let payload = this.getAllPayload();
      http.post('employees', payload).then(json => {
        this.isSubmitting = false;
        this.notif = utils.notif('New Employee Created!', json);
        if (json.success) {
          this.$emit('update:id', json.data.id);
          this.reload(json.data.id);
        }
      });
    },
    resetFormActions: function() {
      for (let i = 0; i < this.forms.length; ++i) {
        for (let j = 0; j < this.forms[i].length; ++j) {
          for (let k = 0; k < this.forms[i][j].length; ++k) {
            this.forms[i][j][k].isSubmitting = false;
          }
        }
      }
    },
    setFormData: function(json) {
      for (let i = 0; i < this.forms.length; ++i) {
        for (let j = 0; j < this.forms[i].length; ++j) {
          for (let k = 0; k < this.forms[i][j].length; ++k) {
            this.forms[i][j][k].model = utils.toModel(
              json,
              this.forms[i][j][k].template
            );
          }
        }
      }
      this.isLoading = false;
    }
  },
  mounted() {
    // if id is set, means that it's an update, otherwise it's an insert new
    if (this.id >= 0) {
      http.get(`employees/${this.id}`).then(json => {
        this.setFormData(json.data);
      });
    } else {
      // nullify all the model for a new form
      this.setFormData(null);
    }
  },
  data() {
    return {
      isArchived: false,
      notif: null,
      formBankDetailsIdx: 3,
      isLoading: true,
      isSubmitting: false,
      forms: [
        [
          [
            {
              title: 'Personal Details',
              model: [],
              template: {
                profile_url: {
                  type: 'file',
                  endpoint: '/photo'
                },
                name: { title: 'Name', type: 'input', required: true },
                gender: {
                  title: 'Gender',
                  type: 'select',
                  options: constants.GENDER
                },
                dob: {
                  title: 'Date of Birth',
                  type: 'datepicker'
                },
                pob: { title: 'Place of Birth', type: 'input' },
                identity_type: {
                  title: 'ID Type',
                  type: 'select',
                  options: constants.ID_TYPE
                },
                identity_no: { title: 'ID Number', type: 'input' },
                marital_status: {
                  title: 'Marital Status',
                  type: 'select',
                  options: constants.MARITAL_STATUS
                },
                religion: {
                  title: 'Religion',
                  type: 'select',
                  options: constants.RELIGION
                },
                blood_type: {
                  title: 'Blood Type',
                  type: 'select',
                  options: constants.BLOOD_TYPE
                },
                highest_education: {
                  title: 'Highest Education',
                  type: 'select',
                  options: constants.HIGHEST_EDU
                },
                institution: { title: 'Institution', type: 'input' }
              },
              isUpdating: false,
              isSubmitting: false
            }
          ],
          [
            {
              title: 'Contact Details',
              model: [],
              template: {
                emails: { title: 'Email', type: 'array', required: true },
                mobile_no: { title: 'Mobile Number', type: 'input' },
                phone_no: { title: 'Phone Number', type: 'input' },
                addresses: { title: 'Address', type: 'array' }
              },
              isUpdating: false,
              isSubmitting: false
            },
            {
              title: 'Emergency Contact Details',
              model: [],
              template: {
                emergency_contacts: {
                  type: 'object',
                  template: {
                    name: { title: 'Name', type: 'input' },
                    address: { title: 'Address', type: 'input' },
                    mobile_no: { title: 'Mobile Number', type: 'input' },
                    phone_no: { title: 'Phone Number', type: 'input' },
                    relation: { title: 'Relation', type: 'input' }
                  }
                }
              },
              isUpdating: false,
              isSubmitting: false
            }
          ]
        ],
        [
          [
            {
              title: 'Employment Details',
              model: [],
              template: {
                employee_no: { title: 'Employee Number', type: 'input' },
                employee_type: {
                  title: 'Employee Type',
                  type: 'select',
                  options: constants.EMPLOYEE_TYPE
                },
                department: {
                  title: 'Department',
                  type: 'select',
                  options: constants.DEPARTMENT,
                  required: true
                },
                job_category: {
                  title: 'Job Category',
                  type: 'select',
                  options: constants.JOB_CATEGORY,
                  required: true
                },
                start_date: {
                  title: 'Start Date',
                  type: 'datepicker'
                },
                is_expat: {
                  title: 'Expat',
                  type: 'select-enum',
                  options: [
                    { id: true, name: 'Yes' },
                    { id: false, name: 'No' }
                  ]
                },
                ignore_attendance: {
                  title: 'Ignore Clock In',
                  type: 'select-enum',
                  options: [
                    { id: true, name: 'Yes' },
                    { id: false, name: 'No' }
                  ]
                },
                salary: {
                  title: 'Basic Salary',
                  type: 'input',
                  inputType: 'number',
                  currency: 'rupiah'
                },
                functional_allowance: {
                  title: 'Functional Allowance',
                  type: 'input',
                  inputType: 'number',
                  currency: 'rupiah'
                },
                food_transport_allowance: {
                  title: 'Food & Transport',
                  type: 'input',
                  inputType: 'number',
                  currency: 'rupiah'
                },
                bpjs_tenaker_staff_contrib: {
                  title: 'BPJS Tenaker Staff Contribution',
                  type: 'input',
                  inputType: 'number',
                  currency: 'rupiah'
                },
                bpjs_tenaker_school_contrib: {
                  title: 'BPJS Tenaker School Contribution',
                  type: 'input',
                  inputType: 'number',
                  currency: 'rupiah'
                },
                bpjs_kesehatan_staff_contrib: {
                  title: 'BPJS Kesehatan Staff Contribution',
                  type: 'input',
                  inputType: 'number',
                  currency: 'rupiah'
                },
                bpjs_kesehatan_school_contrib: {
                  title: 'BPJS Kesehatan School Contribution',
                  type: 'input',
                  inputType: 'number',
                  currency: 'rupiah'
                },
                reksadana_contrib: {
                  title: 'Reksadana Contribution',
                  type: 'input',
                  inputType: 'number',
                  currency: 'rupiah'
                }
              },
              isUpdating: false,
              isSubmitting: false
            }
          ],
          [
            {
              title: 'Bank Account Details',
              model: [],
              template: {
                id_bank: {
                  title: 'Bank Name',
                  type: 'select-enum',
                  options: this.banks
                },
                bank_acc_name: { title: 'Account Name', type: 'input' },
                bank_acc_no: {
                  title: 'Account Number',
                  type: 'input'
                }
              },
              isUpdating: false,
              isSubmitting: false
            },
            {
              title: 'Tax Details',
              model: [],
              template: {
                npwp_no: { title: 'NPWP Number', type: 'input' },
                wajib_pajak_status: {
                  title: 'Status Wajib Pajak',
                  type: 'select',
                  options: constants.WAJIB_PAJAK
                },
                bpjs_tenaker_no: {
                  title: 'No BPJS Ketenagakerjaan',
                  type: 'input'
                },
                bpjs_tenaker_validfrom: {
                  title: 'Valid From',
                  type: 'datepicker'
                },
                bpjs_kesehatan_no: {
                  title: 'No BPJS Kesehatan',
                  type: 'input'
                },
                bpjs_kesehatan_validfrom: {
                  title: 'Valid From',
                  type: 'datepicker'
                }
              },
              isUpdating: false,
              isSubmitting: false
            }
          ]
        ]
      ]
    };
  },
  components: {
    Form,
    Notif,
    AttendanceLog,
    StaffDocs
  }
};
</script>

<style scoped>
.header-group {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
}
.btn-spacing {
  margin-left: 5px;
  margin-right: 5px;
}
.header-btn-group {
  display: flex;
}
.flex-grid {
  display: flex;
  margin-bottom: 10px;
}
.flex-grid-row {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.flex-grid-row > div:not(:last-child) {
  margin-bottom: 10px;
}
.col {
  display: flex;
  flex: 1;
}
.col:nth-child(even) {
  margin-left: 10px;
}
@media all and (max-width: 640px) {
  .header-group {
    flex-flow: column;
  }
  .flex-grid {
    display: block;
    margin-bottom: 5px;
  }
  .col:nth-child(even) {
    margin-left: 0px;
  }
  .col {
    margin-bottom: 5px;
  }
  .flex-grid-row > div:nth-child(odd) {
    margin-bottom: 5px;
  }
  .header-btn-group {
    flex-flow: column;
  }
  .btn-spacing {
    margin-top: 10px;
  }
}
</style>
